module.exports = __webpack_public_path__ + "img/cement_light_grey_ba_list.cb9426e3.jpg";